const isProviderEnabled = (state, name) =>
  Boolean(state.lti.providers.find((p) => p.name === name));

export const isTurnItInEnabled = (state) =>
  isProviderEnabled(state, 'turnitin');

export const tiiMaxGrade = (state) => {
  const tii = state.lti.providers.find((p) => p.name === 'turnitin');
  return tii && tii.maxGrade;
};

export const isBibliuEnabled = (state) => isProviderEnabled(state, 'bibliu');
export const isTalisEnabled = (state) => isProviderEnabled(state, 'talis');
export const isEchoEnabled = (state) => isProviderEnabled(state, 'echo');
export const isPlanetEnabled = (state) => isProviderEnabled(state, 'planet');
export const isPanoptoEnabled = (state) => isProviderEnabled(state, 'panopto');
